import React from "react";
import CartProvider from "./default/contexts/CartContext";
import SettingsProvider from "./default/contexts/SettingContext";
import { ProgressBar } from "./default/progress";
import { RTL } from "./default/rtl";
import ThemeProvider from "./default/theme/theme-provider";
import GlobalDefaultContextRegistry from "./default/global-context";
import { ToastContainer } from "react-toastify";
import HeadClient from "./default/head/head-client";
import { LoadDeferredToastifyStyles } from "./load-deferred-toastify-styles";
import { getGlobalContextValue } from "./utils";
import { fontOpenSans } from "./default/theme/font-family/fonts/open-sans";
export const openSans = fontOpenSans;

export interface VariantProps {
  theme?: "GIFT" | "HEALTH" | "DEFAULT" | "GROCERY" | "FURNITURE";
}

export default async function RootLayout(props: VariantProps & React.PropsWithChildren) {
  const global = await getGlobalContextValue();
  return (
    <html lang="en" suppressHydrationWarning>
      <HeadClient gtag={global.metadata.analytics.gtag} />
      <body className={openSans.className}>
        <noscript>
          <iframe
            src={`https://www.googletagmanager.com/ns.html?id=${global.metadata.analytics.gtag}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          ></iframe>
        </noscript>
        <GlobalDefaultContextRegistry {...global}>
          <CartProvider>
            <SettingsProvider>
              <ThemeProvider theme={props.theme}>
                <ProgressBar />
                <RTL>{props.children}</RTL>
              </ThemeProvider>
            </SettingsProvider>
          </CartProvider>
        </GlobalDefaultContextRegistry>
        <LoadDeferredToastifyStyles />
        <ToastContainer />
      </body>
    </html>
  );
}
